export default { adults: 1, children: 0 };
